<!--
  作者：顾先生
-->
<template>
  <div id="ShouYe">
    <!--    头部+主要内容-->
    <div class="touBox1 clearfix">
      <img src="../assets/zhishi/logo.png" class="logoImg">
      <div class="companyOne">
        <div ref="companyOne" class="autoCompanyOne">
          <span class="autoCompanyOne_span">{{ companyNameUser }}</span>
        </div>
      </div>
      <img src="../assets/zhishi/xin4291.png" class="img4291">
      <div class="zhuTi2 public_boxShaw public_Width">
        <img src="../assets/zhishi/xin4292.png" class="img4292">
        <div class="shujuBox">
          <div class="shujuBox_top">商标详情(地址不一致商标)</div>
          <div class="shujuBox2">
            <div class="xuhao">序号</div>
            <div class="fontBox21">商标名称</div>
            <div class="fontBox22 fontColor">
              <img src="../assets/zhishi/tan.png" class="tan">
              <span>到期日期</span>
            </div>
            <div class="fontBox21">商标注册号</div>
            <div class="fontBox21">商标分类号</div>
          </div>
          <div class="ShowIf" v-if="xianshiOk">
            <div class="XunHuan"  v-for="(item,index) in companyShuju.content" :key="index">
              <div class="shujuBox3">
                <div class="xuhao">{{ (index+1) }}</div>
                <div class="flexStyle">{{ item[0] }}</div>
                <div class="flexStyle fontColor">{{ item[3] }}</div>
                <div class="flexStyle">{{ item[2] }}</div>
                <div class="flexStyle">{{ item[1] }}</div>
              </div>
            </div>
            <div class="shujuBox314">
              <div class="shujuBox314_p1">企业注册地址</div>
              <div class="shujuBox314_p2">{{companyShuju.address}}</div>
            </div>
            <div class="shujuBox314">
              <div class="shujuBox314_p1">商标申请地址</div>
              <div class="shujuBox314_p2">{{companyShuju.sb_address}}</div>
            </div>
          </div>
          <div class="XunHuan" v-if="!xianshiOk">
            <div class="shujuBox3" v-for="(item,index) in fuwuInfo" :key="index">
              <div class="xuhao">{{ (index+1) }}</div>
              <div class="flexStyle">{{ item[0] }}</div>
              <div class="flexStyle fontColor">{{ item[3] }}</div>
              <div class="flexStyle">{{ item[2] }}</div>
              <div class="flexStyle">{{ item[1] }}</div>
            </div>
            <div class="shujuBox314">
              <div class="shujuBox314_p1">企业注册地址</div>
<!--              {{companyShuju.address}}-->
              <div class="shujuBox314_p2">{{companyShuju.address}}</div>
            </div>
            <div class="shujuBox314">
              <div class="shujuBox314_p1">商标申请地址</div>
              <div class="shujuBox314_p2">{{companyShuju.sb_address}}</div>
            </div>
          </div>
        </div>
        <img :src="xiala" class="xiala" @click="xialaBtn" v-if="xialaBtnShow">
      </div>
      <!--    主体-->
      <div class="zhuTi public_boxShaw public_Width clearfix">
        <img src="../assets/zhishi/xin4293.png" class="img4293">
        <img src="../assets/zhishi/xin4294.png" class="img20303">
        <div ref="targetElement" :class=" BtnActive ? 'zhuTiBtn BtnActive':'zhuTiBtn'" @click="lingqu"
             @touchend="handleTouchEnd" @touchstart="handleTouchStart">立即变更商标地址</div>
        <div class="paibianBox_radio">
          <van-checkbox v-model="radio1" checked-color="#D71111">同意签署</van-checkbox>
          <p><span style="color: #D71111" @click="SXShu=true">《信息授权与隐私政策》</span></p>
        </div>
      </div>
      <img src="../assets/zhishi/xin4295.png" class="img4295">
      <div class="ChengXin public_boxShaw public_Width">
        <img class="img2" src="../assets/zhishi/fangda.png" @click="fangfaImg">
      </div>
      <div class="ChengXin public_boxShaw public_Width">
        <img class="img2" src="../assets/zhishi/img2.png">
      </div>
      <div class="zhishi2 public_boxShaw public_Width clearfix">
        <img class="zhishi" src="../assets/zhishi/zhishi.png" @click="weiZixun">
      </div>
      <div class="xaingmu public_boxShaw public_Width clearfix">
        <div class="biaotiBox">
          <img class="biaoti1" src="../assets/zhishi/biaoti.png">
          <div class="biaotiTitle">专业团队 高效办理</div>
          <img class="biaoti2" src="../assets/zhishi/biaoti.png">
        </div>
        <img class="img5" src="../assets/zhishi/img5.png">
        <img class="img6" src="../assets/zhishi/img6.png">
      </div>
      <!--    底部-->
      <bottom></bottom>
      <!--    诚信承诺书-->
      <van-dialog
        v-model="SXShu"
        confirm-button-color="#0075ff"
        confirm-button-text="已阅读"
        message-align="left"
        message="<span style='text-indent: 2em; text-align:justify;display: inline-block;line-height: 6vw;'>尊敬的用户，首先感谢您对我们的信任，我们深知个人信息对您的重要性，确保您的数据安全和隐私保护是我们重要的任务。我们将按照法律法规要求，尽力保护您的个人信息安全可控。在您使用或咨询服务前，请您务必审慎阅读并充分、透彻理解本隐私协议的全部内容和要点，<span style='color:#ff0101;'>特别应重点阅读我们以粗体/下划线标识的条款，确保您充分理解和同意后再开始使用。</span>一旦您使用或者继续咨询服务，即表示您同意本隐私<span style='color:#ff0101;'>政策</span>的全部内容，同意我们按照本协议处理您的个人信息。如果您对本隐私<span style='color:#ff0101;'>政策</span>内容有任何疑问、建议或意见，请通过本平台服务页面提供的在线客服或客服电话<span style='color:#ff0101;'>（400-056-5663）</span>联系我们，对于您不同意本隐私协议的相关内容或条款，您应该停止使用我们提供的产品和服务，<span style='color:#ff0101;'>并避免在未与我们联系的情况下提供任何个人信息。</span></span>
        <p style='display:inline-block;'>一、我们如何收集和使用您的个人信息，为了更好的向您提供产品或服务，您需要向我们授权收集和使用您必要的个人信息，若您未提供服务所必要的相关信息，将导致您无法享受我们给您提供的产品或服务。为了给您提供更好的服务，我们将收集和使用您的如下个人信息，帮助您使用本系统，我们需要您提供包括但不限于联系方式（如联系电话、联系邮箱等），用于系统的登录。</p>
        <p style='display:inline-block;'>您知悉并同意对于您提供的个人信息（包括但不限于联系方式），我们可能会用于咨询服务完成，如企业商标、专利、软件著作权等代办服务所涉及的信息填报、各类服务进度、服务推荐的通知，因此我们可能会自行或者委托第三方通过一种形式或者多种形式向您推送信息，方式主要以短信、电话方式，具体发送形式、频次以我们实际提供为准。如果您不愿接受以上信息通知，您可通过信息中提及的方式进行退订或者直接与我们联系进行退订。</p>
        <p style='display:inline-block;'>如果我们要将您的个人信息用于本政策未载明的其他用途，或将基于特定目的收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。</p>
        <p style='display:inline-block;'>二、我们如何存储与保护您的个人信息，我们<span style='color:#ff0101;'>在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内，且</span>仅会在实现服务完成收集所需的时间内存储您的个人信息，在服务完成后（服务所对应的时间和要求）、在您主动终止服务或主动要求删除信息时，<span style='color:#ff0101;'>我们会尽快的删除您的个人信息。我们会确保依据本政策以及相关法律规定对您的个人信息提供足够的保护。</span></p>
        <p style='display:inline-block;'>我们将会用符合行业标准的安全防护措施保护您提供的个人信息，并对其中关键数据做加密处理，防止个人信息在未经授权的访问、使用、丢失、修改、公开披露或损坏。为了更好的保护您的个人信息，我们会采取<span style='color:#ff0101;'>一切</span>合理可行的措施，将接触您个人信息的范围降低到最小范围。</p>
        <p style='display:inline-block;'>三、我们如何共享、公开披露、转让您的个人信息，我们不会与我们之外的任何第三方组织、个人或者公司共享、转让您的个人信息。如果确实存在必须共享、转让您的个人信息时，我们应当确认第三方组织、个人或者公司已经征得了您的同意，并严格要求第三方对您的个人信息进行保密且使用完成后进行删除。</p>
        <p style='display:inline-block;'>我们重视个人信息的安全与保护，我们承诺不会公开披露您的个人信息，如必须时，我们会向您书面告知公开披露的信息详情与原因，并需要征得您的同意。<span style='color:#ff0101;'>如您希望将您的个人信息转移至您指定的其他个人信息处理者，如您的请求符合法律规定的条件，我们将协助您进行转移。您可以本政策载明的方式联系我们以行使上述权利。</span></p>
        <p style='display:inline-block;'>共享、转让、公开披露个人信息时会有例外，以下情形中，公开披露您的个人信息无需事先征得您的授权同意：</p>
        <p style='display:inline-block;'>(1)您自行向社会公众公开的个人信息；<span style='opacity:0;'>xxxx</span></p>
        <p style='display:inline-block;'>(2)与国家安全、国防安全直接相关的；</p>
        <p style='display:inline-block;'>(3)与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
        <p style='display:inline-block;'>(4)根据个人信息主体履行法律法规规定的义务、维护其享受产品或者服务权力所必需的；</p>
        <p style='display:inline-block;'>(5)出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
        <p style='display:inline-block;'>(6)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
        <p style='display:inline-block;'>(7)国家法律法规规定的其他情形；<span style='opacity:0;'>xxxx</span></p>
        <p style='display:inline-block;'>四、个人信息主体注销账户 ，（1）您可以通过本政策载明的方式联系我们的客服申请账户注销。（2）在您注销账户之后，我们将停止为您提供产品或服务。您曾通过该账户使用的我们的产品与服务下的所有内容、信息、数据、记录将会被删除或匿名化处理。</p>
        <p style='display:inline-block;'>五、对本政策解释说明，如您对本政策的内容存在疑虑，您有权随时通过本政策公开的联系方式要求我们对本政策的相关内容进行解释说明。</p>
        <p style='display:inline-block;'>六、响应您的请求，（1）为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，再行处理您的请求。（2）对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
        <p style='display:inline-block;'>七、我们如何处理儿童的个人信息，我们的产品、网站和服务为商用服务与产品，主要面向企业用户，一般不会向未成年人提供服务。如果我们发现自己在未事先获得未成年监护人同意的情况下收集了儿童的个人信息，我们会设法尽快删除相关信息。</p>
        <p style='display:inline-block;'>八、如何联系我们，如果您对本个人信息保护政策有任何疑问、意见或建议，请通过以下方式与我们联系，一般情况下，我们将在十五个工作日内回复：</p>
        <p style='display:inline-block;'>个人信息保护联系电话：【400-056-5663】</p>
        <p style='display:inline-block;'>个人信息保护联系邮箱：【qishangbanzixun@163.com】</p>
">
        <p slot="title" class="slotTitle">《信息授权与隐私政策》</p>
      </van-dialog>
      <!--    协议-->
      <van-dialog
        v-model="SXxieyi"
        confirm-button-color="#0075ff"
        confirm-button-text="已阅读"
        message-align="left"
        message="<span style='text-indent: 2em; text-align:justify;display: inline-block;line-height: 6vw;'><span style='color:#ff0101;'>企商办一站式知识产权服务商</span>（以下简称“本平台”），是由<span style='color:#ff0101;'>河北企商办企业管理咨询有限公司</span>开发和运营的企业知识产权服务代办平台，主要为经营主体提供知识产权代办（包括但不限于商标、专利、版权、企业注册资本金实缴代办等）服务。</span>
        <p style='display:inline-block;'><span style='color:#ff0101;'>我们郑重提示您，</span>请您在申请注册同意本协议之前，认真阅读本协议和充分理解本协议的全部协议条款内容，<span style='color:#ff0101;'>特别是其中涉及的免除或者限制我们义务与责任的条款、排除或者限制用户权利的条款等，以及以粗体字样标识的内容。</span>您知悉，当您注册为企商办一站式知识产权服务商用户并支付商标、专利、版权、企业注册资本金实缴代办等费用时，即表示您已充分阅读、理解并接受本协议的全部内容。同时，您确认全权委托本平台为您办理商标、专利、版权、企业注册资本金实缴代办等事宜，本平台将通过网络在线方式为您提供相关服务。</p>
        <p style='display:inline-block;'>本协议由您与本平台双方共同缔结，协议对您和本平台双方均有同等效力，本协议仅对与平台就办理商标、专利、版权、企业注册资本金实缴代办等事宜所签署协议文件的付费用户具有法律约束力。鉴于互联网的高速发展，当前协议条款可能无法完全适应未来的变化，因此《隐私政策》等相关协议及规则规范均作为本协议的补充协议，具有同等法律效力。若您付费使用本平台提供的商标、专利、版权、企业注册资本金实缴代办等服务，即视为您同意上述补充说明。<span style='color:#ff0101;'>如您不同意本协议，请立即停止注册或使用我们的服务。</span></p>
        <p style='display:inline-block;'>一、您知悉，按照《中华人民共和国专利法》、《中华人民共和国商标法》、《中华人民共和国著作权法》等相关法律法规，通过国家知识产权局、国家版权局等官方渠道办理知识产权申请、续展、变更、转让等业务，除依法缴纳官方规定的费用外，自行办理无需支付其他代办费用。通过本平台进行知识产权代理、知识产权维权、知识产权评估、知识产权交易等服务，您需向我司支付相应的代理服务费用，具体费用金额以本平台公示的价格为准。请您在委托服务前仔细阅读相关费用说明，并确认同意后进行操作。</p>
        <p style='display:inline-block;'>二、在您支付本平台商标、专利、版权、企业注册资本金实缴代办等服务费用后，即表示您全权委托我司代理您办理相关事宜。您知悉并同意，我司将通过网络在线方式为您提供服务。在办理服务之前，您需向我司提供办理商标、专利、版权、企业注册资本金实缴代办等所需的资料，包括但不限于法定代表人身份证、手机号、经营状况等信息。您应当保证所提供资料的真实性、完整性、合法性。我司将根据您的委托，按照国家知识产权局、国家版权局等相关规定，及时为您办理代办服务。</p>
        <p style='display:inline-block;'>三、您提交商标、专利、版权、企业注册资本金实缴代办资料后，我司一般在200个工作日内完成相关服务（如果由于贵方的原因或贵方继续办理我司其他服务，导致服务时间延长，双方应另行协商确定延长的服务期限及相关事宜）。服务成功的标准为您的商标、专利、版权、企业注册资本金实缴等事项在“国家知识产权局”或其他相关官方平台公示。</p>
        <p style='display:inline-block;'>四、若因不可抗力因素导致本协议的履行或相关服务延迟，您同意我司不承担由此引发的责任。不可抗力因素包括但不限于以下情形：
1.因政府管制造成的临时性关闭、服务调整等；
2.因基础运营商、服务商或主管部门故障、调整导致的影响；
3.因自然灾害、战争、暴乱、司法行政命令、疫情等不可抗力事件；
因常规或紧急的设备或系统维修、设备与系统故障、数据安全完善等。</p>
        <p style='display:inline-block;'>五、服务终止后，您与我司双方将不再受本协议约束。服务终止的情形包括：
1.商标、专利、版权、企业注册资本金实缴服务完结；
2.双方协商一致提前终止服务；
3.因不可抗力或其他不可归责于双方的原因导致协议无法继续履行。
符合上述终止情形，即视为您与我司之间的委托关系终止，本协议的法律约束也随之终止。</p>
        <p style='display:inline-block;'>六、我司为您提供了线上线下的服务咨询通道和服务通知。您可通过企商办一站式知识产权服务商平台进行线上咨询，或拨打我司人工服务电话：400-056-5663（工作日上午08:00-20:00）了解业务进展、反馈问题或提出投诉、异议等。我司将及时处理您的咨询。此外，我司将通过电子邮件、手机短信、微信信息、电话等方式向您发送服务进度通知。为确保服务顺利进行，请您及时关注相关通知。</p>
        <p style='display:inline-block;'>七、我司承诺对您提交的资料采取严格的保密措施。若商标、专利、版权、企业注册资本金实缴代办等服务成功，您提交的资料将保存至下一个续办截止日；若您选择“不公开”，我司将不予保存。若服务未成功或您终止委托关系，我司仅保留您的联系方式。相关材料仅用于办理您委托的事宜，未经您的同意，我司不会向任何第三方公开、提供或发布。若因我司违反本条款引发后果，由我司承担全部责任。</p>
        <p style='display:inline-block;'>八、在商标、专利、版权、企业注册资本金实缴服务期间，若我司未违背本协议约定，您不得向任何第三方发布、提供有损我司利益、形象、名誉的任何信息（包含但不限于我司开发的服务页面、服务流程等），否则我司有权追究您的法律责任。</p>
        <p style='display:inline-block;'>九、<span style='color:#ff0101;'>免责声明：除法律法规有明确规定外，我们将尽最大努力确保<span style='color:#640064;'>企商办一站式知识产权服务商</span>及其所涉及的技术及信息安全、有效、准确、可靠，但受限于现有技术，您理解我们不能对此进行担保。我们的服务是按照现有技术和条件所能达到的现状提供的。我们会尽最大努力向您提供服务，确保服务的连贯性和安全性；但我们不能保证其所提供的服务毫无瑕疵，也无法随时预见和防范技术以及其他风险可能导致的服务中断、数据丢失以及其他的损失和风险。即使我们提供的服务存在瑕疵，但上述瑕疵是当时行业技术水平所无法避免的，其将不被视为我们违约，除法律另有强制性规定外，我们不对您因此受到的损失承担责任。</span></p>
        <p style='display:inline-block;'>十、如果在商标、专利、版权、企业注册资本金实缴代办服务过程中，您与我司产生服务纠纷或者任何争议，双方应尽力友好协商解决，双方协商无果的，可向协议签订的有管辖权的人民法院提起诉讼，本协议签订地为保定市莲池区。</p>
        <p style='display:inline-block;'>十一、<span style='color:#c55e10;'>您在注册企商办一站式知识产权服务商并接受服务时，应该向我们提供真实有效的联系方式（包括您的联系电话），对于联系方式发生变更的，您有义务及时更新有关信息，并保持联系方式畅通。我们将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。我们向您浏览界面推送的弹窗等通知形式，也作为向您发出的有效通知。您应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使通知无法送达或未及时送达，由您自行承担由此可能产生的法律后果。</span></p>
        <p style='display:inline-block;'>十二、<span style='color:#c55e10;'>您使用企商办一站式知识产权服务商或服务即视为您已阅读本协议并接受本协议的约束。我们有权在必要时修改本协议条款。您可以在相关服务页面查阅最新版本的协议条款。本协议条款变更后，如果您继续使用我们提供的软件或服务，即视为您已接受变更后的协议。</span></p>
        <p style='display:inline-block;'>特别提示：
请您在注册或使用服务前仔细阅读本协议，确保充分理解其内容。如有任何疑问，可通过本平台提供的联系方式咨询。感谢您对企商办一站式知识产权服务商的信任与支持！</p>
">
        <p slot="title" class="slotTitle">企商办一站式知识产权服务协议</p>
      </van-dialog>
      <!--      放大图片-->
      <van-popup v-model="FangdaImgShow">
        <img src="../assets/zhishi/fangdaImg.png" class="fangdaImgStyle">
      </van-popup>
      <!--    立即领取悬浮按钮-->
      <Transition>
        <div class="LiJiBtn" v-show="LiJilingquShow" @click="lingqu" ref="xuanfuBtn">
          <img src="../assets/image/lingqu.png" class="LiJiBtn_img">
            <div class="font0306">{{priceNum}}元 / {{ NumPag }}件</div>
        </div>
      </Transition>
      <!--    占位符-->
      <div class="LiJiBtnZhan" v-show="LiJilingquShow"></div>
      <kefu class="kefu_class"></kefu>
    </div>
    <!--    占位符-->
    <van-popup v-model="showZhiFu" round @close="guanbi">
      <div class="showFuBox">
        <img src="../assets/zhishi/font4.png" class="font4">
        <img src="../assets/zhishi/img61.png" class="img6">
        <div class="shujuBox">
          <div class="shujuBox_top_box1">贵司有<span style="color:#FCED97;">{{NumPagBox}}件</span>商标地址不一致。为方便您办理变更，系统已默认全选。<span style="color:#FCED97;">如有不再使用的商标，请取消勾选</span></div>
          <div class="shujuBox_top">商标详情(地址不一致商标)</div>
          <div class="shujuBox2">
            <div class="xuhao">序号</div>
            <div class="fontBox21">商标名称</div>
            <div class="fontBox23 fontColor">
              <img src="../assets/zhishi/tan.png" class="tan">
              <span>到期日期</span>
            </div>
            <div class="fontBox21">商标注册号</div>
            <div class="fontBox21">商标分类号</div>
            <div class="xuhao"></div>
          </div>
          <div class="ShowIf">
            <van-checkbox-group v-model="result" ref="checkboxGroup">
              <div class="XunHuan"  v-for="(item,index) in companyShuju.content" :key="index">
                <div class="shujuBox3">
                  <div class="xuhao">{{ (index+1) }}</div>
                  <div class="flexStyle">{{ item[0] }}</div>
                  <div class="flexStyle fontColor">{{ item[3] }}</div>
                  <div class="flexStyle">{{ item[2] }}</div>
                  <div class="flexStyle">{{ item[1] }}</div>
                  <van-checkbox :name="(item)" class="xuhao" @click="xuhao(item)"></van-checkbox>
                </div>
              </div>
            </van-checkbox-group>
          </div>
<!--          <div class="XunHuan" v-if="!xianshiOk">-->
<!--            <van-checkbox-group v-model="result" ref="checkboxGroup">-->
<!--              <div class="shujuBox3" v-for="(item,index) in fuwuInfo" :key="index">-->
<!--                <div class="xuhao">{{ (index+1) }}</div>-->
<!--                <div class="flexStyle">{{ item[0] }}</div>-->
<!--                <div class="flexStyle">{{ item[1] }}</div>-->
<!--                <div class="flexStyle">{{ item[2] }}</div>-->
<!--                <div class="flexStyle">{{ item[3] }}</div>-->
<!--                <van-checkbox :name="(item)" class="xuhao" @click="xuhao(index)"></van-checkbox>-->
<!--              </div>-->
<!--            </van-checkbox-group>-->
<!--          </div>-->
        </div>
<!--        <img :src="xiala" class="xiala" @click="xialaBtn" v-if="xialaBtnShow">-->
        <div class="Box0305">
          <img src="../assets/zhishi/jiage.png" class="jiage0305">
          <div class="font226">{{ priceNum }}元 / {{ NumPag }}件</div>
        </div>
        <!--    微信支付、支付宝-->
        <div class="WeChatAndZfb">
          <van-radio-group v-model="radio" direction="horizontal" icon-size="15px" checked-color="#dd2424" class="paymentRadio">
            <div class="wechatImg" style="margin-right: 50px">
              <img src="../assets/ZhiFuImg/weixin.png" class="wechatImg_img">
              <van-radio name="1" label-position="left">微信支付</van-radio>
            </div>
            <div class="wechatImg">
              <img src="../assets/ZhiFuImg/zhifubao.png" class="wechatImg_img">
              <van-radio name="2" label-position="left">支付宝</van-radio>
            </div>
          </van-radio-group>
        </div>
        <div :class=" BtnActive ? 'zhuTiBtn BtnActive':'zhuTiBtn'" @click="fukuan"
             @touchend="handleTouchEnd" @touchstart="handleTouchStart">
          立即付费
        </div>
        <div class="paibianBox_radio">
          <van-checkbox v-model="radio1" checked-color="#D71111">同意签署</van-checkbox>
          <p><span style="color: #D71111" @click="SXxieyi=true">《代办服务协议》</span></p>
        </div>
      </div>
    </van-popup>
    <!--    如果用户从微信过来的直接蒙蔽-->
    <div class="WeChatBox" v-if="WeChatBoxIsok"></div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import qs from 'qs'
import { companyInfo, getOpenID, orderGet, weixinNei, weixinWei, zhifubao } from '@/http/api/user'
import bottom from '@/components/bottom.vue'
import Kefu from '@/components/kefu.vue'
import wx from 'weixin-jsapi'

export default {
  name: 'ShouYe',
  // 注册组件
  components: { Kefu, bottom },
  // 数据渲染
  data () {
    return {
      panduanIsOk: true,
      result: [],
      xuanzhong: null,
      showZhiFu: false,
      fuwuInfo: [],
      FangdaImgShow: false,
      xiala: require('@/assets/image/xiala.png'),
      priceNum: 200,
      // 支付选择
      radio: '1',
      // 随机值
      randomNum: '',
      // 按钮效果1
      BtnActive: false,
      companyShuju: {},
      // 诚信承诺书
      SXShu: false,
      // 协议
      SXxieyi: false,
      // 同意签署
      radio1: true,
      checked1: true,
      // 商标名称
      marksName: '',
      companyNameUser: '',
      NumPag: '',
      NumPagBox: '',
      // 立即领取下边按钮
      LiJilingquShow: false,
      xianshiOk: false,
      xialaBtnShow: false,
      ren1: '',
      ren2: '',
      ren3: '',
      ren4: '',
      WeChatBoxIsok: false
    }
  },
  // 注册方法
  methods: {
    guanbi () {
      this.panduanIsOk = false
      this.xianshiOk = false
      this.xiala = require('@/assets/image/xiala.png')
      this.$refs.xuanfuBtn.style.opacity = '1'
    },
    xuhao () {
      if (this.result.length <= 0) {
        Toast('最少选择一项')
        return
      }
      this.NumPag = this.result.length
      if (this.result.length >= 1 && this.result.length <= 3) {
        this.priceNum = 250
      } else if (this.result.length >= 4 && this.result.length <= 10) {
        this.priceNum = 450
      } else if (this.result.length >= 10 && this.result.length <= 20) {
        this.priceNum = 650
      } else if (this.result.length >= 20) {
        this.priceNum = 950
      }
    },
    async fukuan () {
      if (this.result.length <= 0) {
        Toast('最少选择一项')
        return
      }
      // eslint-disable-next-line camelcase
      const sb_name = this.result.map(subArray => subArray.slice(0, 1).join(','))
      // eslint-disable-next-line camelcase
      const sb_no = this.result.map(subArray => subArray.slice(1, 2).join(','))
      if (this.radio === '1') {
        const ua = navigator.userAgent.toLowerCase()
        if (/micromessenger/.test(ua)) {
          const data = await weixinNei(qs.stringify({
            openid: localStorage.getItem('openid'),
            random: localStorage.getItem('RandomNum'),
            price: this.priceNum,
            version: 'A',
            sb_name: sb_name.join(';'),
            sb_no: sb_no.join(';')
          }))
          // 存储订单编号
          localStorage.setItem('orderNo', data.data.order_no)
          wx.config({
            debug: false, // 开启调试模式
            appId: data.data.jsApiParameters.appId, // 公众号的唯一标识
            timestamp: data.data.jsApiParameters.timeStamp, // 生成签名的时间戳
            nonceStr: data.data.jsApiParameters.nonceStr, // 生成签名的随机串
            signature: data.data.jsApiParameters.signType, // 签名
            jsApiList: ['chooseWXPay'] // 填入需要使用的JS接口列表，这里是先声明我们要用到支付的JS接口
          })
          wx.chooseWXPay({
            appId: data.data.jsApiParameters.appId, // appId
            timestamp: data.data.jsApiParameters.timeStamp, // 支付签名时间戳
            nonceStr: data.data.jsApiParameters.nonceStr, // 支付签名随机串
            package: data.data.jsApiParameters.package, // 统一支付接口返回的prepay_id参数值
            signType: data.data.jsApiParameters.signType, // 签名方式
            paySign: data.data.jsApiParameters.paySign, // 支付签名(签名算法看微信开放文档的js-sdk文档的附录1，当然这是后端的事情)
            // 支付成功，跳入支付成功页面，点击完成按钮会进入success和complete函数
            success: function (res) {
              if (res.errMsg === 'chooseWXPay:ok') { // 支付成功进入这个判断
                Toast.success('支付成功!')
                window.location.href = 'https://y8q.cn/A/success'
              }
            },
            // 用户取消支付--实际上进入cancel 和 complate 函数
            cancel: function (res) {
              Toast.fail('取消支付')
            },
            // 支付失败
            fail: function (res) {
              Toast.fail('支付失败')
            }
          })
        } else {
          const { data } = await weixinWei(qs.stringify({
            random: localStorage.getItem('RandomNum'),
            price: this.priceNum,
            synclink: 'https://y8q.cn/A/success',
            version: 'A',
            sb_name: sb_name.join(';'),
            sb_no: sb_no.join(';')
          }))
          // 存储订单编号
          localStorage.setItem('orderNo', data.order_no)
          window.location.href = data.jsApiParameters.h5_url
        }
      } else if (this.radio === '2') {
        console.log(sb_name[0])
        console.log(sb_no[0])
        const data = await zhifubao(qs.stringify({
          random: localStorage.getItem('RandomNum'),
          price: this.priceNum,
          synclink: 'https://y8q.cn/A/success',
          version: 'A',
          sb_name: sb_name.join(';'),
          sb_no: sb_no.join(';')
        }))
        // 存储订单编号
        localStorage.setItem('orderNo', data.data.order_no)
        window.location.href = data.data.h5_url
      }
    },
    fangfaImg () {
      this.FangdaImgShow = true
    },
    xialaBtn () {
      if (this.xianshiOk) {
        this.xianshiOk = false
        this.xiala = require('@/assets/image/xiala.png')
        this.$refs.xuanfuBtn.style.opacity = '1'
      } else {
        // if (this.$refs.checkboxGroup !== undefined) {
        //   if (this.panduanIsOk) {
        //     setTimeout(() => {
        //       this.$refs.checkboxGroup.toggleAll(true)
        //     }, 1)
        //     this.panduanIsOk = false
        //   }
        // }
        this.xianshiOk = true
        this.xiala = require('@/assets/image/shouhui.png')
        this.$refs.xuanfuBtn.style.opacity = '0'
      }
    },
    // 公司名称One适配
    companyOneFun () {
      const dom = this.$refs.companyOne
      const lay = dom.offsetWidth
      const span = dom.children[0].offsetWidth
      const average = span / dom.children[0].innerHTML.split('').length
      if (span + average * 1 > lay) {
        const s = (lay - average * 1) / span
        dom.style.transform = `scale(${s})`
      }
    },
    // 信息初始
    async companyInfo (num) {
      const { data } = await companyInfo(qs.stringify({
        random: this.randomNum,
        type: num
      }))
      this.companyShuju = data
      this.companyNameUser = this.companyShuju.company
      this.fuwuInfo = this.companyShuju.content.slice(0, 2)
      if (this.companyShuju.content.length > 2) {
        this.xialaBtnShow = true
      } else {
        this.xialaBtnShow = false
      }
      this.ren1 = this.companyShuju.content[0][0]
      this.ren2 = this.companyShuju.content[0][1]
      this.ren3 = this.companyShuju.content[0][2]
      this.ren4 = this.companyShuju.content[0][3]
      if (this.companyShuju.content.length >= 1 && this.companyShuju.content.length <= 3) {
        this.priceNum = 250
      } else if (this.companyShuju.content.length >= 4 && this.companyShuju.content.length <= 10) {
        this.priceNum = 450
      } else if (this.companyShuju.content.length >= 10 && this.companyShuju.content.length <= 20) {
        this.priceNum = 650
      } else if (this.companyShuju.content.length >= 20) {
        this.priceNum = 950
      }
      this.NumPagBox = this.companyShuju.content.length
      this.NumPag = this.companyShuju.content.length
      const responseData = this.companyShuju.content.map(item => item[0])
      const resultString = responseData.join(',')
      this.marksName = resultString
      if (num === 2) {
        setTimeout(() => {
          this.$refs.checkboxGroup.toggleAll(true)
        }, 400)
      }
    },
    // 截取网页随机值
    subUtils (data, isOkNum) {
      const index = data.lastIndexOf('/')
      data = data.substring(index + 1, data.length)
      if (isOkNum === 1) {
        this.randomNum = data
        localStorage.setItem('RandomNum', this.randomNum)
      } else {
        this.randomNum = data.substring(0, data.lastIndexOf('?'))
        localStorage.setItem('RandomNum', this.randomNum)
      }
    },
    // code获取
    getCode () {
      const code = this.getUrlParam('code') // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      const local = window.location.href
      if (code == null || code === '') {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5f0390c0b91be146&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
      } else {
        this.subUtils(window.location.href, 2)
        this.getOpenid(code) // 把code传给后台获取用户信息
        this.WeChatBoxIsok = false
      }
    },
    getUrlParam: function (name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      const r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
    // 获取openid
    async getOpenid (code) {
      const data = await getOpenID(qs.stringify({
        code: code
      }))
      localStorage.setItem('openid', data.data)
    },
    // 按钮点击领取
    lingqu () {
      this.showZhiFu = true
      this.panduanIsOk = true
      this.companyInfo(2)
      // if (this.radio1) {
      //   const data = await zhifubao(qs.stringify({
      //     random: this.randomNum,
      //     price: this.priceNum,
      //     marks: this.marksName,
      //     version: 'G',
      //     synclink: 'https://e8o.cn/G/success'
      //   }))
      //   // 存储订单编号
      //   localStorage.setItem('orderNo', data.data.order_no)
      //   window.location.href = data.data.h5_url
      // } else {
      //   Toast.fail('勾选同意协议')
      // }
    },
    // 支付回跳
    zhiFuLoaction () {
      setInterval(async () => {
        const data = await orderGet(qs.stringify({
          order_no: localStorage.getItem('orderNo')
        }))
        if (data.code === 200) {
          window.location.href = 'https://y8q.cn/A/success'
        }
      }, 1000)
    },
    // 拨打客服电话
    boZixun () {
      window.location.href = 'tel://15075266990'
    },
    // 微信客服
    weiZixun () {
      window.location.href = 'https://work.weixin.qq.com/kfid/kfc2f7ba12adb97363c'
    },
    // 手指触摸
    handleTouchStart () {
      this.BtnActive = true
    },
    handleTouchEnd () {
      this.BtnActive = false
    }
  },
  watch: {
    companyNameUser (news, jiu) {
      this.$nextTick(() => {
        this.companyOneFun()
      })
    }
  },
  // 页面初次解析完成
  created () {
    window.scrollTo({
      left: 0,
      top: 0
    })
    const ua = navigator.userAgent.toLowerCase()
    if (/micromessenger/.test(ua)) {
      this.WeChatBoxIsok = true
      this.getCode()
    } else {
      // window.location.href https://p6f.cn/r/65
      this.subUtils(window.location.href, 1)
    }
    // 公司信息
    this.companyInfo(1)
  },
  // 页面内容渲染完成
  mounted () {
    // 立即领取弹出
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 元素进入视口
          this.LiJilingquShow = false
        } else {
          // 元素离开视口
          this.LiJilingquShow = true
        }
      })
    })
    observer.observe(this.$refs.targetElement)
    // 公司名称适配One
    this.companyOneFun()
    this.zhiFuLoaction()
  }
}
</script>

<style lang="less" scoped>
.WeChatBox{
  position: absolute;
  top: 0;
  z-index: 99999999999;
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
}
.showFuBox{
  max-height: 580px;
  .zhuTiBtn {
    width: 265px;
    height: 40px;
    background: #D71111;
    border-radius: 20px;
    position: relative;
    margin: 15px auto 0;
    text-align: center;
    font-weight: bold;
    box-shadow: 0 3px 2px 0 #9F320D;
    letter-spacing: 2px;
    color: #ffffff;
    transition: all .2s;
    line-height: 40px;
    font-size: 20px;
  }
  // 单选按钮
  .paibianBox_radio {
    margin: 16px auto 0;
    display: flex;
    transform: scale(.9);
    justify-content: center;
    line-height: 1;
    font-size: 13px;

    /deep/ .van-checkbox__icon {
      font-size: 13px;
    }

    /deep/ .van-checkbox__label {
      margin-left: 4px;
      font-size: 13px;
      line-height: 0;
    }
  }
  width: 345px;
  padding: 22px 0 13px 0;
  .font4{
    width: 235px;
    display: block;
    margin: 0 auto 0;
  }
  .font5{
    width: 130px;
    display: block;
    margin: 25px auto 0;
  }
  .img6{
    width: 325px;
    display: block;
    margin: 15px auto 0;
  }
  .Box0305{
    margin: 12px auto 0;
    position: relative;
    width: 325px;
    height: 62.5px;
    .jiage0305{
      width: 100%;
      height: 175px;
    }
  }
}
.xuhao{
  padding-left: 6px;
  width: 30px;
  text-align: center;
  font-weight: 500;
  font-size: 11px;
  color: #333333;
}
.fangdaImgStyle{
  width: 360px;
  height: 150px;
}
.xiala{
  display: block;
  margin: 10px auto 0;
  width: 80px;
}
.LiJiBtn_img{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 320px;
  display: block;
  //transform-origin: 0 0;
  //animation: Liji 1s linear infinite;
}
.font0306{
  position: absolute;
  left: 32px;
  bottom: 11px;
  font-size: 14px;
  font-weight: bold;
  color: #bf3229;
}
// 占位符
.LiJiBtnZhan{
  height: 70px;
}
// 公司名称
.companyOne{
  margin: 15px auto 0;
  width: 95%;
  .autoCompanyOne{
    width:100%;
    display: flex;
    line-height: 1;
    justify-content: center;
    .autoCompanyOne_span{
      font-weight: bold;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 23px;
      white-space:nowrap;
      letter-spacing: 1px;
      margin-left: -1px;
    }
  }
}
.shujuBox {
  width: 325px;
  background: #FFFFFF;
  border-radius: 10px;
  border: 1px solid #415ACA;
  margin: 10px auto 0;
  font-size: 12px;
  overflow: hidden;
  .shujuBox_top_box1{
    padding: 6px 13px;
    font-weight: bold;
    font-size: 13px;
    color: #FFFFFF;
    line-height: 19px;
    background-color: #cd5357;
  }
  .shujuBox_top{
    width: 325px;
    height: 33px;
    background: linear-gradient(-78deg, #415ACA, #476DDF);
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    line-height: 33px;
    color: #FFFFFF;
  }
  .shujuBox314{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #CDCDCD;
    .shujuBox314_p1{
      width: 85px;
      height: 25px;
      line-height: 25px;
      border-right: 1px solid #CDCDCD;
      text-align: center;
      font-weight: 500;
      font-size: 11px;
      color: #333333;
    }
    .shujuBox314_p2::-webkit-scrollbar {
      display: none; /* 隐藏滚动条(Chrome/Safari) */
    }
    .shujuBox314_p2{
      width: 220px;
      //white-space: nowrap; /* 防止文本换行 */
      //overflow: hidden; /* 隐藏溢出的文本 */
      //text-overflow: ellipsis; /* 显示省略号 */
      overflow-x: auto;  /* 横向滚动条自动显示 */
      white-space: nowrap; /* 禁止子元素换行 */
      -webkit-overflow-scrolling: touch; /* 移动端顺滑滚动 */
      scrollbar-width: none; /* 隐藏滚动条(Firefox) */
      margin-left: 7px;
      font-size: 10px;
      color: #666666;
    }
  }
  .shujuBox314:last-child{
    border-bottom: none;
  }
  .XunHuan{
    .shujuBox3{
      display: flex;
      align-items: center;
      width: 324px;
      height: 28px;
      border-bottom: 1px solid #CDCDCD;
      .flexStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex: 1;
        text-align: center;
        font-size: 10px;
        color: #333333;
      }
    }
  }

  // 新增506
  .fontColor{
    color: #d71111 !important;
  }
  .tan{
    display: block;
    width: 8.5px;
    height: 8.5px;
    margin-right: 4px;
  }
  .fontBox22{
    margin-left: 6px;
    width: 70px;
    display: flex;
    align-items: center;
    font-weight: 500;
    text-align: center;
    font-size: 11px;
    color: #333333;
  }
  .fontBox23{
    width: 65px;
    display: flex;
    align-items: center;
    font-weight: 500;
    text-align: center;
    font-size: 11px;
    color: #333333;
  }
  // 新增506

  .shujuBox2{
    width: 324px;
    height: 28px;
    background: linear-gradient(-78deg, rgba(117, 221, 249, 0.18), rgba(100, 185, 253, 0.16));
    display: flex;
    align-items: center;
    .fontBox21{
      flex: 1;
      font-weight: 500;
      text-align: center;
      font-size: 11px;
      color: #333333;
    }
  }
}
.Box0305{
  margin: 12px auto 0;
  position: relative;
  width: 325px;
  height: 62.5px;
  .jiage0305{
    width: 100%;
    height: 170px;
  }
}
.font226{
  position: absolute;
  right: 35px;
  top: 22px;
  width: 160px;
  //background-color: pink;
  text-align: right;
  font-size: 14px;
  font-weight: bold;
  color: #bf3229;
  .font226_span{
    font-size: 12px;
    color: #828080;
    font-weight: normal;
  }
}
// 微信支付支付宝样式
.WeChatAndZfb{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .paymentRadio{
    font-size: 12px;
    font-weight: bold;
    color: #333333;
    .van-radio--horizontal{
      margin-right: 0px;
    }
    .wechatImg{
      display: flex;
      align-items: center;
      .wechatImg_img{
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
}
// 悬浮
.v-enter-active,
.v-leave-active {
  transform: translateY(100px);
}

.v-enter-from,
.v-leave-to {
  transform: translateY(100px);
}
// 立即领取悬浮
.LiJiBtn{
  position: fixed;
  bottom: 0;
  z-index: 999;
  width: 100%;
  height: 70px;
  transition: all .5s;
  background-color: #fff;
}
.imgFlex{
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.LiJiBtn_img_right{
  margin-right: 15px;
}
// 守信承诺书标题
.slotTitle {
  font-size: 18px;
  color: #0075ff;
}

// 守信承诺书内容
.slotdefault {
  padding: 4px 24px 4px 24px;
  font-size: 14px;
}

.slotdefault1 {
  text-indent: 2em;
  line-height: 22px;
  color: #646566;
}

.slotdefault2, .slotdefault3 {
  color: #646566;
}

.slotdefault3 {
  text-align: right;
}

.slotdefault4 {
  padding-bottom: 20px;
}

// 客服
.kefu_class {
  position: fixed;
  right: 0px;
  z-index: 9999;
  bottom: 75px;
}

.v-enter-active,
.v-leave-active {
  transform: translateY(100px);
}

.v-enter-from,
.v-leave-to {
  transform: translateY(100px);
}

@keyframes Liji {
  0% {
    transform: scale(1) translate(-50%, -50%);
  }
  25% {
    transform: scale(.95) translate(-50%, -50%);
  }
  100% {
    transform: scale(1) translate(-50%, -50%);
  }
}
@keyframes Liji2 {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(.95);
  }
  100% {
    transform: scale(1);
  }
}

#ShouYe {
  position: relative;
}

.touBox1 {
  height: 390px;
  background-image: url("../assets/zhishi/index-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.logoImg{
  margin-top: 10px;
  margin-left: 20px;
  height: 27px;
}
.img4295{
  display: block;
  margin: 10px auto;
  width: 345px;
}
.img4293{
  position: absolute;
  left: 50%;
  top: -11px;
  transform: translateX(-50%);
  display: block;
  width: 325px;
  //border-radius: 8px;
  //box-shadow: 0px 1px 4px 1px rgba(169,112,70,0.52);
}
.img4291{
  display: block;
  margin: 13px auto 0;
  width: 345px;
  //border-radius: 8px;
  //box-shadow: 0px 1px 4px 1px rgba(169,112,70,0.52);
}
.img4292{
  display: block;
  margin: 0 auto;
  width: 325px;
  //border-radius: 8px;
  //box-shadow: 0px 1px 4px 1px rgba(169,112,70,0.52);
}
.img0303{
  display: block;
  margin: 0 auto;
  width: 345px;
  border-radius: 8px;
  box-shadow: 0px 1px 4px 1px rgba(169,112,70,0.52);
}
.img20303{
  width: 325px;
  display: block;
  margin: 45px auto 0;
}
.xin427{
  width: 325px;
  display: block;
  margin: 15px auto 0;
}
.zhuTi2 {
  padding: 11px 0;
  margin-top: 10px;
  background-color: #FFFFFF;
  .font226Xin{
    width: 100%;
    text-align: center;
    font-weight: 400;
    font-size: 17px;
    color: #FC6701;
  }
  .font226Xin2{
    width: 306px;
    margin: 0 auto 0;
    font-size: 13px;
    color: #333333;
  }
}
.img1 {
  display: block;
  margin: 0 auto;
  width: 283px;
}

.top2 {
  margin-top: 15px;
  height: 38px;
  background: #FFFFFF;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  .bao {
    width: 12px;
    height: 13px;
  }

  .font1 {
    margin-left: 3px;
    font-weight: 400;
    font-size: 13px;
    color: #A0785E;
  }
}
.Box0306{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 16px;
  z-index: 99;
  width: 240px;
  height: 33px;
  background: #FC6701;
  border-radius: 10px;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  line-height: 33px;
}
.zhuTi {
  position: relative;
  margin-top: 21px;
  padding: 0 0 14px 0;
  background-color: #ffffff;
  .huiyaun{
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    .huiyuanImg{
      width: 18px;
      margin-right: 4px;
    }
    .huiyuanFont{
      font-weight: 500;
      letter-spacing: 1px;
      font-size: 14px;
      color: #B08652;
    }
  }
  .zhuTiBtn {
    width: 265px;
    height: 40px;
    background: #D71111;
    border-radius: 20px;
    position: relative;
    margin: 15px auto 0;
    text-align: center;
    font-weight: bold;
    box-shadow: 0 3px 2px 0 #9F320D;
    letter-spacing: 2px;
    color: #ffffff;
    transition: all .2s;
    font-size: 20px;
    line-height: 40px;
  }

  // 单选按钮
  .paibianBox_radio {
    margin: 16px auto 0;
    display: flex;
    transform: scale(.9);
    justify-content: center;
    line-height: 1;
    font-size: 13px;

    /deep/ .van-checkbox__icon {
      font-size: 13px;
    }

    /deep/ .van-checkbox__label {
      margin-left: 4px;
      font-size: 13px;
      line-height: 0;
    }
  }
}

.ChengXin {
  padding: 20px 15px 15px 12px;

  .img2 {
    width: 318px;
  }
}

.tixing {
  padding: 10px;

  .box {
    width: 325px;
    height: 67px;
    background: #FFEDD7;
    border-radius: 10px;
    display: flex;
    align-items: center;

    .boxFont {
      width: 450px;
      font-size: 12px;
      color: #AF8450;
      line-height: 16px;
      text-align: justify;
      transform: scale(.9);
    }
  }
}

.xaingmu {
  .img5 {
    display: block;
    margin: 3px auto 0;
    width: 315px;
  }

  .img6 {
    display: block;
    margin: 4px auto 15px;
    width: 305px;
  }

  .biaotiBox {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .biaoti1 {
      width: 36px;
      height: 4px;
    }

    .biaotiTitle {
      margin-left: 5px;
      margin-right: 5px;
      font-weight: bold;
      font-size: 17px;
      color: #B16A2C;
    }

    .biaoti2 {
      width: 36px;
      height: 4px;
      transform: rotate(180deg);
    }
  }

  .fuwu {
    margin: 15px auto 0;
    display: block;
    width: 315px;
    height: 190px;
  }

  .biaotiBox2 {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .zixun1 {
      margin-right: 15px;
    }

    .zixun1,
    .zixun2 {
      width: 150px;
      height: 37px;
    }
  }
}

.zhishi2 {
  .zhishi {
    padding: 13px 13px 15px 13px;
    display: flex;
    margin: 0 auto;
    width: 323px;
    height: 315px;
  }
}
</style>
